<div class="custom-control custom-switch">
  <input (change)="valueChanged.emit($event)" type="checkbox" class="custom-control-input" [formControl]="formControl" [id]="id" checked [disabled]="isReadOnly">
  <label class="custom-control-label" [for]="id">{{ labelText  | translate}}</label>
</div>
